// extracted by mini-css-extract-plugin
export var base = "_1f-0";
export var updateBanner = "_1f-1";